import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import { QUICK_EXIT_URL } from '../../content/site';
import { BRAND } from '../../styles/ui';

// Leave immediately: forget the signed-in session on this device, then swap this page
// for an everyday one so the back button doesn't return to Joan.
export const quickExit = () => {
  try {
    ['accessToken', 'idToken', 'refreshToken'].forEach((key) => localStorage.removeItem(key));
    sessionStorage.clear();
  } catch {
    // Storage blocked: still leave
  }
  window.location.replace(QUICK_EXIT_URL);
};

const QuickExitButton: React.FC = () => (
  <Tooltip title="Leave this site now. Opens BBC Weather.">
    <Button
      onClick={quickExit}
      size="small"
      aria-label="Quick exit: leave this site now"
      sx={{
        backgroundColor: BRAND.ink,
        color: 'var(--joan-bg)',
        borderRadius: '50px',
        px: 2,
        whiteSpace: 'nowrap',
        '&:hover': { backgroundColor: BRAND.ink, opacity: 0.85 }
      }}
    >
      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Quick exit</Box>
      <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>Exit</Box>
    </Button>
  </Tooltip>
);

export default QuickExitButton;
